.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
}

.logo {
  height: 100%;
  width: auto;
  object-fit: contain;
}
